module.exports = __webpack_public_path__ + "media/images/icons/flags/TL-20261bfbc6e9fa093e6ca0034ae40753.svg";